
import React, { Component } from "react";
import './App.scss';
import logoFrom from './assets/img/logos/logo/logo.svg';
import logo1 from './assets/img/logos/logo/logo-light.svg';
import img1 from './assets/img/illustrations/wizard/type-1.svg';
import img2 from './assets/img/illustrations/wizard/type-2.svg';
import finish from './assets/img/illustrations/wizard/finish.svg';
import finisDark from './assets/img/illustrations/wizard/finish-dark.svg';
import uploadPlaceholder from './assets/img/illustrations/wizard/upload-placeholder.svg';
import teamPlaceholder from "./assets/img/illustrations/wizard/team-placeholder.svg";
import img3 from './assets/img/illustrations/wizard/type-3.svg';
import FeatherIcon from 'feather-icons-react';
import $ from 'jquery';

class App extends Component{ 
  constructor() {
    super();    
    this.wizardHandler = this.wizardHandler.bind(this);
    this.goToStep = this.goToStep.bind(this); 
    this.handleProgress = this.handleProgress.bind(this); 
    this.buildProjectPreview = this.buildProjectPreview.bind(this);
    this.dropdownItemHandker =  this.dropdownItemHandker.bind(this);
  }


  componentDidMount(){
    $('.dropdown-trigger').on('click', function () {
      $('.dropdown').removeClass('is-active');
      $(this).addClass('is-active');
    });
    

    $(document).on('click', function (e) {
        var target = e.target;
        if (!$(target).is('.dropdown img, .kill-drop') && !$(target).parents().is('.dropdown')) {
            $('.dropdown').removeClass('is-active');
        }
        if ($(target).is('.kill-drop')) {
            $('.dropdown').removeClass('is-active');
        }
    });
  }

  delay = 1200; 
   currentStep = 0;
   project = {
    customer: {},
    info: {},
    members: [],
    tools: []
};  




 buildProjectPreview(object) {
  //1. Handle Project Type
  var typeIcon;
  if (object.type == 'UI/UX Design') {
      typeIcon = `
          <div class="h-icon is-medium is-warning is-rounded">
              <i class="lnil lnil-vector-pen"></i>
          </div>
      `;
  }

  else if (object.type == 'Web Development') {
      typeIcon = `
          <div class="h-icon is-medium is-info is-rounded">
              <i class="lnil lnil-layout"></i>
          </div>
      `;
  }

  else if (object.type == 'Marketing') {
      typeIcon = `
          <div class="h-icon is-medium is-success is-rounded">
              <i class="lnil lnil-megaphone"></i>
          </div>
      `;
  }
  var typeTemplate = `
      <div class="media-flex-center">
          ${typeIcon}
          <div class="flex-meta">
              <span>${object.type}</span>
              <span>Project Type</span>
          </div>
      </div>
  `;

  $('#project-preview-type').find('.media-flex-center').remove();
  $('#project-preview-type').append(typeTemplate);

  //2. Project Name & description
  if (this.project.name != '') {
      $('#project-preview-title span').html(this.project.name);
  } else {
      $('#project-preview-title span').html('Project Name Goes Here');
  }
  
  if (this.project.description != '') {
      $('#project-preview-description').html(this.project.description);
  } else {
      $('#project-preview-description').html('You didn\'t enter any description. You can edit it anytime by clicking on the small edit icon.');
  }
  

  //3. Project Customer
  if (this.project.customer.logoUrl != undefined || this.project.customer.name != '') {
      $('#project-preview-customer-logo').attr('src', this.project.customer.logoUrl);
      $('#project-preview-customer-name').html(this.project.customer.name);
      $('#project-preview-customer-placeholder').addClass('is-hidden');
      $('#project-preview-customer-block').removeClass('is-hidden');
  }

  else {
      $('#project-preview-customer-block').addClass('is-hidden');
      $('#project-preview-customer-placeholder').removeClass('is-hidden');
  }
  
  //4. Project Info
  $('#project-preview-budget span').html(this.project.info.budget);
  if (this.project.info.date != '') {
      $('#project-preview-date span').html(this.project.info.date);
  } else {
      $('#project-preview-date span').html('Unset');
  }
  
  $('#project-preview-attachments span').html(this.project.info.attachments);

  //5. Team
  $('#project-preview-team .media-list-item:not(.is-owner)').remove();
  for (var m = 0; m < this.project.members.length; m++) {
      var teamTemplate = `
          <div class="media-list-item">
              <div class="media-flex-center">
                  <div class="h-avatar">
                      <img class="avatar" src="${this.project.members[m].photoUrl}">
                  </div>
                  <div class="flex-meta">
                      <span>${this.project.members[m].name}</span>
                      <span>Member</span>
                  </div>
              </div>
          </div>
      `
      $('#project-preview-team').append(teamTemplate);
  }

  //6. Tools
  $('#project-preview-tools .media-list-item').remove();
  if (this.project.tools.length > 0) {
      $('#project-preview-tools-placeholder').addClass('is-hidden');
      $('#project-preview-tools').removeClass('is-hidden');

      for (var t = 0; t < this.project.tools.length; t++) {
          var toolTemplate = `
              <div class="media-list-item">
                  <div class="media-flex-center">
                      <div class="h-avatar is-small">
                          <img class="avatar" src="${this.project.tools[t].photoUrl}">
                      </div>
                      <div class="flex-meta">
                          <span>${this.project.tools[t].name}</span>
                          <span>${this.project.tools[t].type}</span>
                      </div>
                  </div>
              </div>
          `
          $('#project-preview-tools').append(toolTemplate);
      }
  }
  
  else {
      $('#project-preview-tools').addClass('is-hidden');
      $('#project-preview-tools-placeholder').removeClass('is-hidden');
  }

  console.log(this.project);
}

 
  dropdownItemHandker = (e) => {    
    e.preventDefault();
    var stp = e.target;
    var targetStep = parseInt(stp.getAttribute('data-dropdown-step'));
    this.goToStep(targetStep);
    
  } 
   
   
  wizardHandler = (e) => {   
    e.preventDefault();    
    var ele =  e.target;
    var projectType =  ele.closest('.wizard-card').querySelector('h3').innerHTML;
    this.project.type = projectType;
    ele.classList.add("is-loading");
    setTimeout(
      function() {
          ele.classList.remove('is-loading');
          this.goToStep(this.currentStep + 1);
      }
      .bind(this),
      this.delay
    );     
  } 

  prviousHandler = (e) => {
    e.preventDefault();
    var elePrev =  e.target; 
    elePrev.classList.add("is-loading");  
    setTimeout(
      function(){
        elePrev.classList.remove('is-loading');
        this.goToStep(this.currentStep - 1);
      }
      .bind(this),this.delay
    )
  }

  nextHandler = (e) => {
    e.preventDefault();
    var eleNxt =  e.target; 
    eleNxt.classList.add("is-loading");
    if (this.currentStep == 1) {
      this.project.name = $('#project-name').val();
      this.project.description = $('#project-description').val();
    }
    else if (this.currentStep == 2) {
      this.project.customer.logoUrl = $('.media-flex-center:not(.is-hidden) #customer-logo').attr('src');
      this.project.customer.name = $('.media-flex-center:not(.is-hidden) #customer-name').text();
      this.project.info.date = $('#project-end-date').val();
      this.project.info.budget = $('.budget-item-inner.is-active span').text();  
    }
    else if (this.currentStep == 3) {
      this.project.info.attachments = $('.preview-box').length;
  }
    else if (this.currentStep == 4) {
      this.project.members.splice(0, this.project.members.length);
      var invitedCount = $('.invited-member').length;
      if (invitedCount > 0) {
          $('.invited-member').each(function(){
              var memberPhoto = $(this).find('img').attr('src');
              var memberName = $(this).find('.meta p').text();
              this.project.members.push({
                  name: memberName,
                  photoUrl: memberPhoto
              });
          });
      }      
     }
     else if (this.currentStep == 5) {
      this.project.tools.splice(0, this.project.tools.length);
      var toolsCount = $('.tool-card input:checked').length;
      if (toolsCount > 0) {
          $('.tool-card input:checked').each(function(){
              var container = $(this).closest('.tool-card');
              var toolPhoto = container.find('img').attr('src');
              var toolName = container.find('.flex-meta span:first-child').text();
              var toolType = container.find('.flex-meta span:nth-child(2)').text();
              this.project.tools.push({
                  name: toolName,
                  photoUrl: toolPhoto,
                  type: toolType
              });
          });
      }
    }
    setTimeout(
      function () {        
        eleNxt.classList.remove('is-loading');
        this.goToStep(this.currentStep + 1);
      }.bind(this),this.delay);

  }

  goToStep(step){    
    this.currentStep = step;
    $('.wizard-v1-wrapper .inner-wrapper').removeClass('is-active');
    $('#wizard-step-' + step).addClass('is-active');
    var stepTitle = $('.inner-wrapper.is-active').attr('data-step-title');
    var titleHtml = `
        <span class="title-wrap">Step ${step + 1}: <span>${stepTitle}</span></span>    `
    $('.is-wizard-title').html(titleHtml);
    $('.project-preview-loader').addClass('is-active')
    if (this.currentStep > 0) {           
        $('.wizard-buttons').addClass('is-active');
    }
    if (this.currentStep === 0) {      
      this.handleProgress(15);
      $('.wizard-buttons').removeClass('is-active');
    }
    else if (this.currentStep === 1) {      
       this.handleProgress(25);
    
    }else if (this.currentStep == 2) {
      this.handleProgress(45);
    }

    else if (this.currentStep == 3) {
      this.handleProgress(60);
    }

    else if (this.currentStep == 4) {
      this.handleProgress(75);
    }

    else if (this.currentStep == 5) {
      this.handleProgress(85);
    }

    else if (this.currentStep == 6) {
      this.handleProgress(95);
      this.buildProjectPreview(this.project);
      setTimeout(
        function () {
              $('.project-preview-loader').removeClass('is-active');              
          }.bind(), this.delay)
      }

      else if (this.currentStep == 7) {
          this.handleProgress(100);
          $('.wizard-buttons').removeClass('is-active');
          $('.wizard-dropdown').addClass('is-hidden');
      }

    $('[data-dropdown-step="' + step + '"]').removeClass('is-disabled');

  }

  handleProgress(value) { 
    console.log(value);
    $('#wizard-progress').val(value);
  }
  render(){
    return( 
      <div id="huro-app" classname="app-wrapper">
        <nav className="wizard-navigation">
          <a href="/" className="wizard-brand">
            <img className="light-image" src={logoFrom} alt ="logo"/>
            <img className="dark-image" src={logo1} alt = "logo" />
          </a>
          <div className="navbar-item is-wizard-title">
            <span className="title-wrap">Step 1: <span>Project Type</span></span>
          </div>
          <div className="dropdown wizard-dropdown dropdown-trigger">
            <div className="is-trigger">             
              <FeatherIcon icon="chevron-down" />
            </div>
            <div id="wizard-navigation-dropdown" className="dropdown-menu" role="menu">
              <div className="dropdown-content">
                <a onClick={this.dropdownItemHandker} href="javascript:void(0);" className="dropdown-item kill-drop" data-dropdown-step={0}>
                  Step 1: Project Type
                </a>
                <a  onClick={this.dropdownItemHandker} href="javascript:void(0);" className="dropdown-item kill-drop is-disabled" data-dropdown-step={1}>
                  Step 2: Project Info
                </a>
                <a onClick={this.dropdownItemHandker} href="javascript:void(0);" className="dropdown-item kill-drop is-disabled" data-dropdown-step={2}>
                  Step 3: Project Details
                </a>
                <a onClick={this.dropdownItemHandker} href="javascript:void(0);" className="dropdown-item kill-drop is-disabled" data-dropdown-step={3}>
                  Step 4: Project Files
                </a>
                <a onClick={this.dropdownItemHandker} href="javascript:void(0);" className="dropdown-item kill-drop is-disabled" data-dropdown-step={4}>
                  Step 5: Team Members
                </a>
                <a onClick={this.dropdownItemHandker} href="javascript:void(0);" className="dropdown-item kill-drop is-disabled" data-dropdown-step={5}>
                  Step 6: Project Tools
                </a>
                <a onClick={this.dropdownItemHandker} href="javascript:void(0);" className="dropdown-item kill-drop is-disabled" data-dropdown-step={6}>
                  Step 7: Preview
                </a>
              </div>
            </div>
          </div>
          <div className="navbar-item is-dark-mode">
            <div className="navbar-icon">
              <label className="dark-mode">
                <input type="checkbox" defaultChecked />
                <span />
              </label>
            </div>
          </div>
          <div className="dropdown is-right dropdown-trigger user-dropdown">
            <div className="is-trigger" aria-haspopup="true">
              <div className="profile-avatar">
                <img className="avatar" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/avatars/photos/8.jpg" alt />
              </div>
              <i data-feather="chevron-down" />
            </div>
            <div className="dropdown-menu" role="menu">
              <div className="dropdown-content">
                <div className="dropdown-item">
                  <p className="is-size-7 dark-inverted">Erik Kovalsky</p>
                </div>
                <a href="#" className="dropdown-item">
                  <i data-feather="user" />
                  <span>Profile</span>
                </a>
                <a className="dropdown-item">
                  <i data-feather="edit-2" />
                  <span>Edit Profile</span>
                </a>
                <a className="dropdown-item">
                  <i data-feather="box" />
                  <span>Projects</span>
                </a>
                <a className="dropdown-item">
                  <i data-feather="settings" />
                  <span>Settings</span>
                </a>
                <hr className="dropdown-divider" />
                <a href="#" className="dropdown-item">
                  <i data-feather="log-out" />
                  <span>Sign Out</span>
                </a>
              </div>
            </div>
          </div>
        </nav>

        <progress id="wizard-progress" className="progress is-smaller is-primary wizard-progress" value={10} max={100} />
        <div className="wizard-v1-wrapper">
          <div id="wizard-step-0" className="inner-wrapper is-active" data-step-title="Project Type">
            <div className="step-content">
              <div className="step-title">
                <h2 className="dark-inverted">Select a project type</h2>
              </div>
              <div className="wizard-types">
                <div className="columns">
                  <div className="column is-4">
                    <div className="wizard-card">
                      <img  src={img1} alt="img1" />
                      <h3 className="dark-inverted">UI/UX Design</h3>
                      <p>Some short explanation about the type goes here.</p>
                      <div className="button-wrap">
                        <a href="#" onClick = {this.wizardHandler} className="button h-button is-primary is-rounded is-elevated is-bold type-select-button">Continue</a>
                      </div>
                      <div className="learn-more-link">
                        <a href="#" className="dark-inverted-hover">Or Learn More</a>
                      </div>
                    </div>
                  </div>
                  <div className="column is-4">
                    <div className="wizard-card">
                      <img  src={img2} alt="img1" />
                      <h3 className="dark-inverted">Web Development</h3>
                      <p>Some short explanation about the type goes here.</p>
                      <div className="button-wrap">
                        <a href="#" className="button h-button is-primary is-rounded is-elevated is-bold type-select-button">Continue</a>
                      </div>
                      <div className="learn-more-link">
                        <a href="#" className="dark-inverted-hover">Or Learn More</a>
                      </div>
                    </div>
                  </div>
                  <div className="column is-4">
                    <div className="wizard-card">
                      <img  src={img3} alt="img1" />
                      <h3 className="dark-inverted">Marketing</h3>
                      <p>Some short explanation about the type goes here.</p>
                      <div className="button-wrap">
                        <a href="#" className="button h-button is-primary is-rounded is-elevated is-bold type-select-button">Continue</a>
                      </div>
                      <div className="learn-more-link">
                        <a href="#" className="dark-inverted-hover">Or Learn More</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="wizard-step-1" className="inner-wrapper" data-step-title="Project Info">
            <div className="step-content">
              <div className="step-title">
                <h2 className="dark-inverted">What is this project about?</h2>
                <p>Manage better by adding all relevant project information</p>
              </div>
              <div className="project-info">
                <div className="project-info-head">
                  <div className="project-avatar-upload">
                    <div className="filepond-profile-wrap is-small">
                      <input type="file" className="profile-filepond" name="profile_filepond" accept="image/png, image/jpeg, image/gif" />
                    </div>
                    <p>
                      <span>Upload a project logo</span>
                      <span>File size cannot exceed 2MB</span>
                    </p>
                  </div>
                  <div className="project-info">
                    <div className="project-name">
                      <div className="field">
                        <div className="control">
                          <input id="project-name" className="input" placeholder="Project Name" />
                        </div>
                      </div>
                    </div>
                    <div className="project-description p-t-10">
                      <div className="field">
                        <div className="control">
                          <textarea id="project-description" className="textarea" rows={4} placeholder="Describe your project..." defaultValue={""} />
                        </div>
                        <p className="help">Minimum of 50 characters</p>
                      </div>
                      <div className="field">
                        <label>Related Industries</label>
                        <div className="control">
                          <input id="choices-text-remove-button" className="input" defaultValue="UI/UX Design" placeholder="Enter something" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="wizard-step-2" className="inner-wrapper" data-step-title="Project Details">
            <div className="step-content">
              <div className="step-title">
                <h2 className="dark-inverted">Add more details</h2>
                <p>Add useful details to your project. You can edit this later.</p>
              </div>
              <div className="project-customer">
                <h4>Customer</h4>
                <div className="field is-autocomplete">
                  <div className="control has-icon">
                    <input id="customers-search" className="input" placeholder="search..." />
                    <div className="form-icon">
                      <i data-feather="search" />
                    </div>
                  </div>
                </div>
                <div className="media-flex-center is-hidden">
                  <div className="h-avatar is-medium">
                    <img id="customer-logo" className="avatar" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/brands/airbnb.svg" alt />
                  </div>
                  <div className="flex-meta">
                    <span id="customer-name">Airbnb</span>
                    <span id="customer-location">Los Angeles, CA</span>
                  </div>
                  <div className="flex-end">
                    <button id="remove-customer" className="button is-circle">
                      <span className="icon is-small">
                        <i data-feather="x" />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="project-dates">
                <h4>Project Time Frame</h4>
                <div className="project-dates-inner">
                  <div className="project-date">
                    <div className="date-icon">
                      <i data-feather="map-pin" />
                    </div>
                    <div className="control">
                      <input id="project-start-date" className="input form-datepicker" placeholder="Start Date" />
                    </div>
                  </div>
                  <div className="separator" />
                  <div className="project-date">
                    <div className="date-icon">
                      <i data-feather="flag" />
                    </div>
                    <div className="control">
                      <input id="project-end-date" className="input form-datepicker" placeholder="End Date" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="project-budget">
                <h4>Project Budget</h4>
                <div className="project-budget-inner">
                  <div className="budget-item">
                    <a className="budget-item-inner is-active">
                      <span>&lt; 5K</span>
                    </a>
                    <a className="budget-item-inner">
                      <span>&lt; 30K</span>
                    </a>
                    <a className="budget-item-inner">
                      <span>&lt; 100K</span>
                    </a>
                    <a className="budget-item-inner">
                      <span>100K+</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="wizard-step-3" className="inner-wrapper" data-step-title="Project Files">
            <div className="step-content">
              <div className="step-title">
                <h2 className="dark-inverted">Add files to this project</h2>
                <p>Or you can skip this step. You can always add more files later.</p>
              </div>
              {/*List Empty Search Placeholder */}
              <div className="page-placeholder is-files">
                <div className="placeholder-content">
                  <img className="light-image is-rounded" src={uploadPlaceholder} alt="uploadPlaceholder" />
                  <img className="dark-image is-rounded" src={uploadPlaceholder} alt="uploadPlaceholder" />
                  <h3>Upload project files</h3>
                  <p className="is-larger">You can already start adding files to your project if you have them handy. But don't worry, you'll be able to add and manage files later.</p>
                  <a className="action-link toggle-uploader-link">Add Files</a>
                </div>
              </div>
              <div className="uploader is-hidden">
                <div id="actions" className="uploader-toolbar">
                  <div className="left">
                    <div className="uploader-actions">
                      <div className="uploader-action">
                        <span className="inner-action fileinput-button hint--bubble hint--primary hint--top" data-hint="Add Files">
                          <i data-feather="plus" />
                        </span>
                      </div>
                      <div className="uploader-action">
                        <button type="submit" className="inner-action start hint--bubble hint--primary hint--top" data-hint="Upload All">
                          <i data-feather="upload" />
                        </button>
                      </div>
                      <div className="uploader-action">
                        <button type="reset" className="inner-action cancel hint--bubble hint--primary hint--top" data-hint="Remove All">
                          <i data-feather="x" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="right">
                    {/* The global file processing state */}
                    <div className="fileupload-process">
                      <div id="total-progress" className="progress progress-striped active" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={0}>
                        <div className="progress-bar progress-bar-success" data-dz-uploadprogress />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="uploader-container">
                  <div className="upload-wrapper">
                    <div className="upload-box fileinput-button">
                      <div className="uploader-label">
                        <i className="lnil lnil-cloud-upload" />
                        <h3>Upload photos/videos</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="template-list" id="previews">
                  <div id="template" className="template-list-item">
                    <div className="preview-box">
                      {/* This is used as the file preview template */}
                      <div className="preview">
                        <img data-dz-thumbnail src="https://via.placeholder.com/150x150" alt />
                      </div>
                      <div className="list-item-meta">
                        <p className="name" data-dz-name />
                        <p className="error text-danger" data-dz-errormessage />
                      </div>
                      <div className="list-item-progress">
                        <p className="size" data-dz-size />
                        <div className="progress active" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={0}>
                          <div className="progress-bar progress-bar-success" data-dz-uploadprogress>
                          </div>
                        </div>
                      </div>
                      <div className="list-item-actions">
                        <button className="list-item-action start hint--bubble hint--primary hint--top" data-hint="Upload File">
                          <i data-feather="play" />
                        </button>
                        <button data-dz-remove className="list-item-action cancel hint--bubble hint--primary hint--top" data-hint="Cancel">
                          <i data-feather="arrow-left" />
                        </button>
                        <button data-dz-remove className="list-item-action delete">
                          <i data-feather="trash-2" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="wizard-step-4" className="inner-wrapper" data-step-title="Team Members">
            <div className="step-content">
              <div className="step-title">
                <h2 className="dark-inverted">Who will be working on this project?</h2>
                <p>Start by adding members to your team</p>
              </div>
              {/*List Empty Search Placeholder */}
              <div className="page-placeholder is-people">
                <div className="placeholder-content">
                  <img className="light-image is-rounded" src={teamPlaceholder} alt="teamPlaceholder" />
                  <img className="dark-image is-rounded" src={teamPlaceholder} alt="teamPlaceholder" />
                  <h3>Invite People</h3>
                  <p className="is-larger">You can already start adding files to your project if you have them handy. But don't
                    worry, you'll be able to add and manage files later.</p>
                  <a className="action-link toggle-members-link">Add Members</a>
                </div>
              </div>
              <div className="project-team-wrapper is-hidden">
                <div className="project-team-header">
                  <div className="field is-autocomplete">
                    <div className="control has-icon">
                      <input id="add-member" className="input" placeholder="Search teammates..." />
                      <div className="form-icon">
                        <i data-feather="search" />
                      </div>
                    </div>
                  </div>
                  <div className="h-avatar is-big">
                    <img className="avatar" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/avatars/photos/8.jpg" alt data-user-popover={3} />
                    <img className="badge" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/icons/flags/united-states-of-america.svg" alt />
                  </div>
                  <h3 className="title is-4 is-narrow is-thin">Erik Kovalsky</h3>
                  <p className="light-text">You are the project owner</p>
                </div>
                <div className="project-team-body">
                  <div className="members-list">
                    <div className="empty-wrap has-text-centered">
                      <span>No team members yet</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="wizard-step-5" className="inner-wrapper" data-step-title="Project Tools">
            <div className="step-content">
              <div className="step-title">
                <h2 className="dark-inverted">What tools will you be using?</h2>
                <p>Choose a set of tools that you'll be using in this project.</p>
              </div>
              <div className="tools-wrapper">
                <div className="columns is-multiline">
                  {/*Tool*/}
                  <div className="column is-4">
                    <div className="tool-card">
                      <input type="checkbox" />
                      <div className="tool-card-inner">
                        <div className="media-flex-center">
                          <div className="h-avatar">
                            <img className="avatar is-squared" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/illustrator.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span>Illustrator</span>
                            <span>Design Software</span>
                          </div>
                          <div className="flex-end">
                            <div className="checkmark">
                              <i data-feather="check" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Tool*/}
                  <div className="column is-4">
                    <div className="tool-card">
                      <input type="checkbox" />
                      <div className="tool-card-inner">
                        <div className="media-flex-center">
                          <div className="h-avatar">
                            <img className="avatar is-squared" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/photoshop.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span>Photoshop</span>
                            <span>Design Software</span>
                          </div>
                          <div className="flex-end">
                            <div className="checkmark">
                              <i data-feather="check" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Tool*/}
                  <div className="column is-4">
                    <div className="tool-card">
                      <input type="checkbox" />
                      <div className="tool-card-inner">
                        <div className="media-flex-center">
                          <div className="h-avatar">
                            <img className="avatar is-squared" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/xd.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span>Adobe XD</span>
                            <span>Design Software</span>
                          </div>
                          <div className="flex-end">
                            <div className="checkmark">
                              <i data-feather="check" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Tool*/}
                  <div className="column is-4">
                    <div className="tool-card">
                      <input type="checkbox" />
                      <div className="tool-card-inner">
                        <div className="media-flex-center">
                          <div className="h-avatar">
                            <img className="avatar is-squared" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/figma.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span>Figma</span>
                            <span>Design Software</span>
                          </div>
                          <div className="flex-end">
                            <div className="checkmark">
                              <i data-feather="check" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Tool*/}
                  <div className="column is-4">
                    <div className="tool-card">
                      <input type="checkbox" />
                      <div className="tool-card-inner">
                        <div className="media-flex-center">
                          <div className="h-avatar">
                            <img className="avatar is-squared" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/invision.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span>Invision</span>
                            <span>Design Software</span>
                          </div>
                          <div className="flex-end">
                            <div className="checkmark">
                              <i data-feather="check" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Tool*/}
                  <div className="column is-4">
                    <div className="tool-card">
                      <input type="checkbox" />
                      <div className="tool-card-inner">
                        <div className="media-flex-center">
                          <div className="h-avatar">
                            <img className="avatar is-squared" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/jira.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span>Jira</span>
                            <span>Issue Tracker</span>
                          </div>
                          <div className="flex-end">
                            <div className="checkmark">
                              <i data-feather="check" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Tool*/}
                  <div className="column is-4">
                    <div className="tool-card">
                      <input type="checkbox" />
                      <div className="tool-card-inner">
                        <div className="media-flex-center">
                          <div className="h-avatar">
                            <img className="avatar is-squared" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/taiga.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span>Taiga</span>
                            <span>Scrumboard</span>
                          </div>
                          <div className="flex-end">
                            <div className="checkmark">
                              <i data-feather="check" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Tool*/}
                  <div className="column is-4">
                    <div className="tool-card">
                      <input type="checkbox" />
                      <div className="tool-card-inner">
                        <div className="media-flex-center">
                          <div className="h-avatar">
                            <img className="avatar is-squared" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/slack.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span>Slack</span>
                            <span>Messaging App</span>
                          </div>
                          <div className="flex-end">
                            <div className="checkmark">
                              <i data-feather="check" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Tool*/}
                  <div className="column is-4">
                    <div className="tool-card">
                      <input type="checkbox" />
                      <div className="tool-card-inner">
                        <div className="media-flex-center">
                          <div className="h-avatar">
                            <img className="avatar is-squared" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/asana.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span>Asana</span>
                            <span>Task Manager</span>
                          </div>
                          <div className="flex-end">
                            <div className="checkmark">
                              <i data-feather="check" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Tool*/}
                  <div className="column is-4">
                    <div className="tool-card">
                      <input type="checkbox" />
                      <div className="tool-card-inner">
                        <div className="media-flex-center">
                          <div className="h-avatar">
                            <img className="avatar is-squared" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/teamwork.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span>Teamwork</span>
                            <span>Collaborative App</span>
                          </div>
                          <div className="flex-end">
                            <div className="checkmark">
                              <i data-feather="check" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Tool*/}
                  <div className="column is-4">
                    <div className="tool-card">
                      <input type="checkbox" />
                      <div className="tool-card-inner">
                        <div className="media-flex-center">
                          <div className="h-avatar">
                            <img className="avatar is-squared" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/github.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span>GitHub</span>
                            <span>Code Repository</span>
                          </div>
                          <div className="flex-end">
                            <div className="checkmark">
                              <i data-feather="check" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*Tool*/}
                  <div className="column is-4">
                    <div className="tool-card">
                      <input type="checkbox" />
                      <div className="tool-card-inner">
                        <div className="media-flex-center">
                          <div className="h-avatar">
                            <img className="avatar is-squared" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/gitlab.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span>Gitlab</span>
                            <span>Code Repository</span>
                          </div>
                          <div className="flex-end">
                            <div className="checkmark">
                              <i data-feather="check" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div id="wizard-step-6" className="inner-wrapper" data-step-title="Preview">
            <div className="step-content">
              <div className="step-title">
                <h2 className="dark-inverted">Make sure everything is good</h2>
                <p>You can go back to previous steps if you need to edit anything.</p>
              </div>
              <div className="project-preview-wrapper">
                <div className="project-preview-loader is-active">
                  <div className="loader is-loading" />
                </div>
                <div className="project-preview-header">
                  <div className="h-avatar is-big">
                    <div id="project-preview-fake-logo" className="avatar is-fake is-h-green">
                      <span>P</span>
                    </div>
                    <img id="project-preview-logo" className="avatar is-hidden" src="https://via.placeholder.com/150x150" alt />
                    <a className="edit-icon" data-step-edit={1}>
                      <i className="lnil lnil-pencil" />
                    </a>
                  </div>
                  <h3 id="project-preview-title" className="title is-4 is-narrow is-thin">
                    <span>Project Title Goes Here</span>
                    <a className="edit-icon">
                      <i className="lnil lnil-pencil" data-step-edit={1} />
                    </a> 
                  </h3>
                </div>
                <div className="project-preview-body">
                  <div className="columns is-multiline">
                    <div className="column is-12 is-tablet-100">
                      <div className="edit-box">
                        <h4>Description</h4>
                        <div className="edit-icon" data-step-edit={1}>
                          <i className="lnil lnil-pencil" />
                        </div>
                        <p id="project-preview-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis negat? Tamen a proposito, inquam,
                          aberramus. Deinde dolorem quem maximum? Quae duo sunt, unum facit. Quod vestri non item.</p>
                      </div>
                    </div>
                    <div className="column is-6 is-tablet-50">
                      <div id="project-preview-type" className="edit-box">
                        <div className="edit-icon" data-step-edit={0}>
                          <i className="lnil lnil-pencil" />
                        </div>
                        <div className="media-flex-center">
                          <div className="h-icon is-medium is-warning is-rounded">
                            <i className="lnil lnil-vector-pen" />
                          </div>
                          <div className="flex-meta">
                            <span>UI/UX Design</span>
                            <span>Project Type</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="column is-6 is-tablet-50">
                      <div className="edit-box">
                        <div className="edit-icon" data-step-edit={2}>
                          <i className="lnil lnil-pencil" />
                        </div>
                        <div id="project-preview-customer-block" className="media-flex-center">
                          <div className="h-avatar is-medium">
                            <img id="project-preview-customer-logo" className="avatar" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/brands/airbnb.svg" alt />
                          </div>
                          <div className="flex-meta">
                            <span id="project-preview-customer-name">Airbnb</span>
                            <span>Project Customer</span>
                          </div>
                        </div>
                        <div id="project-preview-customer-placeholder" className="edit-box-placeholder is-media is-hidden">
                          <span>No selected customer</span>
                        </div>
                      </div>
                    </div>
                    <div className="column is-4 is-tablet-33">
                      <div className="edit-box">
                        <div className="edit-icon" data-step-edit={2}>
                          <i className="lnil lnil-pencil" />
                        </div>
                        <div className="estimated-budget">
                          <div className="inner-block">
                            <div id="project-preview-budget" className="budget">
                              <span>&lt; 30K</span>
                            </div>
                            <p>Estimated Budget</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="column is-4 is-tablet-33">
                      <div className="edit-box">
                        <div className="edit-icon" data-step-edit={2}>
                          <i className="lnil lnil-pencil" />
                        </div>
                        <div className="estimated-due-date">
                          <div className="inner-block">
                            <div id="project-preview-date" className="date">
                              <span>Oct 20, 2020</span>
                            </div>
                            <p>Estimated Due Date</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="column is-4 is-tablet-33">
                      <div className="edit-box">
                        <div className="edit-icon" data-step-edit={3}>
                          <i className="lnil lnil-pencil" />
                        </div>
                        <div className="attachments-count">
                          <div className="inner-block">
                            <div id="project-preview-attachments" className="attachments">
                              <span>3</span>
                            </div>
                            <p>Attachments</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="column is-6 is-tablet-50">
                      <div className="edit-box">
                        <h4>Team</h4>
                        <div className="edit-icon" data-step-edit={4}>
                          <i className="lnil lnil-pencil" />
                        </div>
                        <div id="project-preview-team" className="media-list">
                          <div className="media-list-item is-owner">
                            <div className="media-flex-center">
                              <div className="h-avatar">
                                <img className="avatar" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/avatars/photos/8.jpg" alt data-user-popover={3} />
                              </div>
                              <div className="flex-meta">
                                <span>Erik K.</span>
                                <span>Owner</span>
                              </div>
                            </div>
                          </div>
                          <div className="media-list-item">
                            <div className="media-flex-center">
                              <div className="h-avatar">
                                <img className="avatar" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/avatars/photos/7.jpg" alt data-user-popover={0} />
                              </div>
                              <div className="flex-meta">
                                <span>Alice C.</span>
                                <span>Member</span>
                              </div>
                            </div>
                          </div>
                          <div className="media-list-item">
                            <div className="media-flex-center">
                              <div className="h-avatar">
                                <img className="avatar" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/avatars/photos/25.jpg" alt data-user-popover={4} />
                              </div>
                              <div className="flex-meta">
                                <span>Melany W.</span>
                                <span>Member</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="column is-6 is-tablet-50">
                      <div className="edit-box">
                        <h4>Tools</h4>
                        <div className="edit-icon" data-step-edit={5}>
                          <i className="lnil lnil-pencil" />
                        </div>
                        <div id="project-preview-tools-placeholder" className="edit-box-placeholder is-list is-hidden">
                          <span>No selected tools</span>
                        </div>
                        <div id="project-preview-tools" className="media-list">
                          <div className="media-list-item">
                            <div className="media-flex-center">
                              <div className="h-avatar is-small">
                                <img className="avatar" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/illustrator.svg" alt />
                              </div>
                              <div className="flex-meta">
                                <span>Illustrator</span>
                                <span>Design Software</span>
                              </div>
                            </div>
                          </div>
                          <div className="media-list-item">
                            <div className="media-flex-center">
                              <div className="h-avatar is-small">
                                <img className="avatar" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/figma.svg" alt />
                              </div>
                              <div className="flex-meta">
                                <span>Figma</span>
                                <span>Design Software</span>
                              </div>
                            </div>
                          </div>
                          <div className="media-list-item">
                            <div className="media-flex-center">
                              <div className="h-avatar is-small">
                                <img className="avatar" src="https://via.placeholder.com/150x150" data-demo-src="assets/img/photo/demo/tools/taiga.svg" alt />
                              </div>
                              <div className="flex-meta">
                                <span>Taiga</span>
                                <span>Scrumboard</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div id="wizard-step-7" className="inner-wrapper" data-step-title="Finish">
            <div className="step-content">
              <div className="step-title">
                <h2 className="dark-inverted">Congrats! You're all set.</h2>
                <p>Awesome, you just finished creating this project.</p>
              </div>
              <div className="page-placeholder end-placeholder">
                <div className="placeholder-content">
                  <img className="light-image" src={finish} alt="finish" />
                  <img className="dark-image" src={finisDark} alt="finishDark" />
                  <h3>Get ready for next steps.</h3>
                  <p>You, and the team members you've added can already start working and creating tasks.</p>
                  <div className="button-wrap">
                    <a className="button h-button is-rounded is-bold is-elevated is-primary">View Project</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="wizard-buttons">
            <div cBlassName="wizard-buttons-inner">
              <button onClick={this.prviousHandler} className="button h-button is-light is-bold wizard-button-previous">Previous</button>
              <button onClick={this.nextHandler} className="button h-button is-primary is-bold is-elevated wizard-button-next">Next</button>
            </div>
          </div>
        </div>
      </div>
    );
  }  
}

export default App;